import React, { useState, useCallback } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import firebase from 'firebase/app';
import { userWithDefault } from '../types/user';
import { Root, Hr, H3, Explanation, Message, Textarea } from './common/styled';

export const AdminMail = memoNamed('AdminMail', () => {
  const [mailList, setMailList] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const getMail = useCallback(() => {
    const db = firebase.firestore();
    setMessage('');
    db.collection('Users')
      .where('contact', '==', 'email')
      .where('emailValid', '==', 'new')
      .get()
      .then((snapshot) => {
        setMailList(
          snapshot.docs
            .map((u) => userWithDefault(u.data()).email.value)
            .filter((u) => u)
            .join(',')
        );
      })
      .catch((error) => {
        console.error(error);
        setMessage('データの取得時にエラーが発生しました。');
      });
  }, []);

  const onChangeMailList = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      const _value = event.target.value;
      setMailList(_value);
    },
    []
  );
  return (
    <Root>
      <H3>メールアドレスを取得</H3>
      <Hr />
      <Explanation>
        取得ボタンをクリックすると、会員のうち、「桃源会からの連絡先」が「email」であり、Emailが空欄でなくが不着でも無いユーザについて、Emailアドレスのリストを取得し、テキストボックスに表示します。
        <br />
        ご利用の際はテキストボックスの中にカーソルをあわせ、ctrl-Aで全選択した後ctrl-Cでコピーし、gmailのBCC欄に貼り付けてご利用ください。
      </Explanation>
      <input type='button' onClick={getMail} value='取得' />
      <br />
      <Message>{message}</Message>
      <br />
      <Textarea
        rows={10}
        value={mailList}
        onChange={onChangeMailList}
      ></Textarea>
    </Root>
  );
});
